/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        subtitle: 'Aggregations and overview',
        role: [
            'ROLE_ADMIN',
            'ROLE_RAC',
            'ROLE_MANAGER',
            'ROLE_GENERAL_MANAGER',
        ],
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
    {
        id: 'monitor',
        title: 'Monitor',
        role: [
            'ROLE_GENERAL_MANAGER',
            'ROLE_MANAGER',
            'ROLE_ADMIN',
            'ROLE_USER',
        ],
        type: 'basic',
        icon: 'heroicons_outline:video-camera',
        link: '/monitor',
    },
    {
        id: 'menuDivider',
        type: 'spacer',
    },
    {
        id: 'mainMenu',
        title: 'Menu',
        subtitle: 'Corporate Data Management',
        role: [
            'ROLE_GENERAL_MANAGER',
            'ROLE_MANAGER',
            'ROLE_ADMIN',
            'ROLE_RAC',
        ],
        type: 'group',
    },

    {
        id: 'reports',
        title: 'Reports',
        subtitle: 'Reporting tools',
        type: 'collapsable',
        icon: 'heroicons_outline:presentation-chart-bar',
        // role: ['ROLE_GENERAL_MANAGER', 'ROLE_MANAGER', 'ROLE_ADMIN', 'ROLE_RAC', 'ROLE_US'],
        children: [
            {
                id: 'reports.inventory',
                title: 'Inventory',
                type: 'basic',
                icon: 'heroicons_outline:archive',
                link: '/inventory',
            },
            {
                id: 'reports.combinedInventory',
                title: 'Συνδυαστική Απογραφή',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-check',
                link: '/combined-inventory',
                role: ['ROLE_ADMIN', 'ROLE_MANAGER'],
            },

            {
                id: 'reports.orders',
                title: 'Orders',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-list',
                link: '/orders',
            },
            {
                id: 'reports.history',
                title: 'History',
                type: 'basic',
                icon: 'heroicons_outline:document-search',
                link: '/history',
            },
            {
                id: 'reports.compInventory',
                title: 'Comparative Inventory',
                type: 'collapsable',
                icon: 'heroicons_outline:Layer_1',
                children: [
                    {
                        id: 'compInventoryGen',
                        title: 'Create',
                        type: 'basic',
                        //icon: 'heroicons_outline:Layer_1',
                        link: '/compInventory',
                    },
                    {
                        id: 'compInventoryHistory',
                        title: 'History',
                        type: 'basic',
                        //icon: 'heroicons_outline:Layer_1',
                        link: '/comparative-inventory-history',
                    },
                    //link: '/compInventory'
                ],
            },
        ],
    },

    {
        id: 'raw.data',
        title: 'Raw Data',
        subtitle: 'Pure data tables',
        type: 'collapsable',
        role: [
            'ROLE_GENERAL_MANAGER',
            'ROLE_MANAGER',
            'ROLE_ADMIN',
            'ROLE_RAC',
        ],
        icon: 'heroicons_outline:server',
        children: [
            {
                id: 'raw.data.vehicles',
                title: 'Vehicles',
                type: 'basic',
                icon: 'heroicons_outline:office-building',
                link: '/vehicles',
            },
            // {
            //     id   : 'raw.data.orders',
            //     title: 'Orders',
            //     type : 'basic',
            //     icon : 'mat_outline:query_builder',
            //     link : '/orders'
            // },
            {
                id: 'raw.data.transactions',
                title: 'Transactions',
                type: 'basic',
                icon: 'mat_outline:query_builder',
                link: '/transactions',
            },
        ],
    },
    {
        id: 'admin.form-inventory',
        title: 'Car Check Form Inventory',
        type: 'basic',
        // role: ['ROLE_ADMIN'],
        icon: 'heroicons_outline:document-text',
        link: '/car-check-form-inventory',
    },
    {
        id: 'admin',
        title: 'Admin',
        subtitle: 'Admin tools',
        type: 'group',
        icon: 'heroicons_outline:home',
        role: ['ROLE_ADMIN'],
        children: [
            {
                id: 'admin.users',
                title: 'Users',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'heroicons_outline:users',
                link: '/admin/users',
            },

            // {
            //     id   : 'admin.siteConfig',
            //     title: 'Site config',
            //     type : 'basic',
            //     role: ['ROLE_ADMIN'],
            //     icon : 'mat_outline:code',
            //     link : '/admin/site-config'
            // },
            // {
            //     id: 'integration',
            //     title: 'Integration',
            //     subtitle: 'Third-party integration',
            //     type: 'basic',
            //     role: ['ROLE_ADMIN'],
            //     icon: 'mat_outline:laptop',
            //     link : 'admin/third-party'
            // }
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        subtitle: 'Aggregations and overview',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
    {
        id: 'monitor',
        title: 'Monitor readers',
        type: 'basic',
        icon: 'heroicons_outline:video-camera',
        link: '/monitor',
    },
    {
        id: 'menuDivider',
        type: 'spacer',
    },
    {
        id: 'mainMenu',
        title: 'Menu',
        subtitle: 'Corporate Data Management',
        type: 'group',
    },
    {
        id: 'reports',
        title: 'Reports',
        subtitle: 'Reporting tools',
        type: 'collapsable',
        icon: 'heroicons_outline:presentation-chart-bar',
        children: [
            {
                id: 'reports.inventory',
                title: 'Inventory',
                type: 'basic',
                icon: 'heroicons_outline:archive',
                link: '/inventory',
            },
            {
                id: 'reports.combinedInventory',
                title: 'Συνδυαστική Απογραφή',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-check',
                link: '/combined-inventory',
                role: ['ROLE_ADMIN', 'ROLE_SUPER_USER'],
            },

            {
                id: 'reports.history',
                title: 'History',
                type: 'basic',
                icon: 'heroicons_outline:document-search',
                link: '/history',
            },
            {
                id: 'reports.serviced',
                title: 'Serviced',
                type: 'basic',
                icon: 'heroicons_outline:presentation-chart-bar',
            },
        ],
    },
    {
        id: 'raw.data',
        title: 'Raw Data',
        subtitle: 'Pure data tables',
        type: 'collapsable',
        icon: 'heroicons_outline:server',
        children: [
            {
                id: 'raw.data.vehicles',
                title: 'Vehicles',
                type: 'basic',
                icon: 'heroicons_outline:office-building',
                link: '/vehicles',
            },
            // {
            //     id   : 'raw.data.orders',
            //     title: 'Orders',
            //     type : 'basic',
            //     icon : 'mat_outline:query_builder',
            //     link : '/orders'
            // },
            {
                id: 'raw.data.transactions',
                title: 'Transactions',
                type: 'basic',
                icon: 'mat_outline:query_builder',
                link: '/transactions',
            },
        ],
    },
    {
        id: 'admin',
        title: 'Admin',
        subtitle: 'Admin tools',
        type: 'group',
        icon: 'heroicons_outline:home',
        role: ['ROLE_ADMIN'],
        children: [
            {
                id: 'admin.users',
                title: 'Users',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'heroicons_outline:users',
                link: '/admin/users',
            },
            {
                id: 'admin.form-inventory',
                title: 'Car Check Form',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'heroicons_outline:document-text',
                link: '/admin/car-check-form-inventory',
            },
            {
                id: 'admin.siteConfig',
                title: 'Site config',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'mat_outline:code',
                link: '/admin/site-config',
            },
            {
                id: 'integration',
                title: 'Integration',
                subtitle: 'Third-party integration',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'mat_outline:laptop',
                link: 'admin/third-party',
            },
        ],
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        subtitle: 'Aggregations and overview',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
    {
        id: 'monitor',
        title: 'Monitor readers',
        type: 'basic',
        icon: 'heroicons_outline:video-camera',
        link: '/monitor',
    },
    {
        id: 'menuDivider',
        type: 'spacer',
    },
    {
        id: 'mainMenu',
        title: 'Menu',
        subtitle: 'Corporate Data Management',
        type: 'group',
    },
    {
        id: 'reports',
        title: 'Reports',
        subtitle: 'Reporting tools',
        type: 'collapsable',
        icon: 'heroicons_outline:presentation-chart-bar',
        children: [
            {
                id: 'reports.inventory',
                title: 'Inventory',
                type: 'basic',
                icon: 'heroicons_outline:archive',
                link: '/inventory',
            },
            {
                id: 'reports.combinedInventory',
                title: 'Συνδυαστική Απογραφή',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-check',
                link: '/combined-inventory',
                role: ['ROLE_ADMIN', 'ROLE_SUPER_USER'],
            },

            {
                id: 'reports.history',
                title: 'History',
                type: 'basic',
                icon: 'heroicons_outline:document-search',
                link: '/history',
            },
            {
                id: 'reports.serviced',
                title: 'Serviced',
                type: 'basic',
                icon: 'heroicons_outline:presentation-chart-bar',
            },
        ],
    },
    {
        id: 'raw.data',
        title: 'Raw Data',
        subtitle: 'Pure data tables',
        type: 'collapsable',
        icon: 'heroicons_outline:server',
        children: [
            {
                id: 'raw.data.vehicles',
                title: 'Vehicles',
                type: 'basic',
                icon: 'heroicons_outline:office-building',
                link: '/vehicles',
            },
            {
                id: 'raw.data.orders',
                title: 'Orders',
                type: 'basic',
                icon: 'mat_outline:query_builder',
                link: '/orders',
            },
            {
                id: 'raw.data.transactions',
                title: 'Transactions',
                type: 'basic',
                icon: 'mat_outline:query_builder',
                link: '/transactions',
            },
        ],
    },
    {
        id: 'admin',
        title: 'Admin',
        subtitle: 'Admin tools',
        type: 'group',
        icon: 'heroicons_outline:home',
        role: ['ROLE_ADMIN'],
        children: [
            {
                id: 'admin.users',
                title: 'Users',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'heroicons_outline:users',
                link: '/admin/users',
            },
            {
                id: 'admin.form-inventory',
                title: 'Car Check Form',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'heroicons_outline:document-text',
                link: '/admin/car-check-form-inventory',
            },
            {
                id: 'admin.siteConfig',
                title: 'Site config',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'mat_outline:code',
                link: '/admin/site-config',
            },
            {
                id: 'thirdPartyIntegration',
                title: 'Third-Party',
                subtitle: 'Third-party integration',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'mat_outline:laptop',
                link: 'admin/third-party',
            },
        ],
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        subtitle: 'Aggregations and overview',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/dashboard',
    },
    {
        id: 'monitor',
        title: 'Monitor readers',
        type: 'basic',
        icon: 'heroicons_outline:video-camera',
        link: '/monitor',
    },
    {
        id: 'menuDivider',
        type: 'spacer',
    },
    {
        id: 'mainMenu',
        title: 'Menu',
        subtitle: 'Corporate Data Management',
        type: 'group',
    },
    {
        id: 'reports',
        title: 'Reports',
        subtitle: 'Reporting tools',
        type: 'collapsable',
        icon: 'heroicons_outline:presentation-chart-bar',
        children: [
            {
                id: 'reports.inventory',
                title: 'Inventory',
                type: 'basic',
                icon: 'heroicons_outline:archive',
                link: '/inventory',
            },
            {
                id: 'reports.combinedInventory',
                title: 'Συνδυαστική Απογραφή',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-check',
                link: '/combined-inventory',
                role: ['ROLE_ADMIN', 'ROLE_SUPER_USER'],
            },

            {
                id: 'reports.history',
                title: 'History',
                type: 'basic',
                icon: 'heroicons_outline:document-search',
                link: '/history',
            },
            {
                id: 'reports.serviced',
                title: 'Serviced',
                type: 'basic',
                icon: 'heroicons_outline:presentation-chart-bar',
            },
        ],
    },
    {
        id: 'raw.data',
        title: 'Raw Data',
        subtitle: 'Pure data tables',
        type: 'collapsable',
        icon: 'heroicons_outline:server',
        children: [
            {
                id: 'raw.data.vehicles',
                title: 'Vehicles',
                type: 'basic',
                icon: 'heroicons_outline:office-building',
                link: '/vehicles',
            },
            {
                id: 'raw.data.orders',
                title: 'Orders',
                type: 'basic',
                icon: 'mat_outline:query_builder',
                link: '/orders',
            },
            {
                id: 'raw.data.transactions',
                title: 'Transactions',
                type: 'basic',
                icon: 'mat_outline:query_builder',
                link: '/transactions',
            },
        ],
    },
    {
        id: 'admin',
        title: 'Admin',
        subtitle: 'Admin tools',
        type: 'group',
        icon: 'heroicons_outline:home',
        role: ['ROLE_ADMIN'],
        children: [
            {
                id: 'admin.users',
                title: 'Users',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'heroicons_outline:users',
                link: '/admin/users',
            },
            {
                id: 'admin.form-inventory',
                title: 'Car Check Form',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'heroicons_outline:document-text',
                link: '/admin/car-check-form-inventory',
            },
            {
                id: 'admin.siteConfig',
                title: 'Site config',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'mat_outline:code',
                link: '/admin/site-config',
            },
            {
                id: 'thirdPartyIntegration',
                title: 'Third-Party',
                subtitle: 'Third-party integration',
                type: 'basic',
                role: ['ROLE_ADMIN'],
                icon: 'mat_outline:laptop',
                link: 'admin/third-party',
            },
        ],
    },
];
